import {
  BiDashboardPermission,
  BiDashboardSummary,
} from '@euler/model/bi/dashboard';
import { useServiceFactory } from '@euler/services/factory';
import { useLocalObservable } from '@euler/utils/hooks/useLocalObservable';
import { catchError, from, map } from 'rxjs';

export type BiEditableDashboards =
  | { kind: 'loading' }
  | { kind: 'ready'; dashboards: BiDashboardSummary[] }
  | { kind: 'failed' };

const kEditable = new Set([
  BiDashboardPermission.Edit,
  BiDashboardPermission.Manage,
]);

/** Every dashboard of the store the caller may add a card to. */
export function useEditableDashboards(): BiEditableDashboards {
  const { biService } = useServiceFactory();
  return useLocalObservable<BiEditableDashboards>(
    () =>
      from(biService.dashboards()).pipe(
        map(
          (list): BiEditableDashboards => ({
            kind: 'ready',
            dashboards: list.filter(item => kEditable.has(item.permission)),
          }),
        ),
        catchError((error): [BiEditableDashboards] => {
          console.error('BI dashboards failed', error);
          return [{ kind: 'failed' }];
        }),
      ),
    { kind: 'loading' },
    [biService],
  );
}
